<template>
  <v-container class="fill-height auth-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <AuthBrandHeader />

        <v-card class="auth-card" flat>
          <v-card-text class="pa-6">
            <!-- Loading state -->
            <div v-if="verifying" class="text-center py-8">
              <v-progress-circular
                indeterminate
                color="primary"
                size="56"
              ></v-progress-circular>
              <h1 class="auth-heading mt-5" style="text-align: center">
                Verifying your email
              </h1>
              <p class="auth-subtext" style="text-align: center">
                This will just take a moment.
              </p>
            </div>

            <!-- Success state -->
            <div v-else-if="verified" class="text-center py-4">
              <v-icon color="success" size="56">mdi-check-circle</v-icon>
              <h1 class="auth-heading mt-4" style="text-align: center">
                You're in, welcome to {{ $config.productName }}
              </h1>
              <p class="auth-subtext" style="text-align: center">
                Your email has been verified. You can now log in to your
                account.
              </p>
              <v-btn class="auth-submit-btn mt-2" large to="/login">
                Continue to login
              </v-btn>
            </div>

            <!-- Error state -->
            <div v-else-if="verificationError" class="text-center py-4">
              <v-icon color="error" size="56">mdi-alert-circle</v-icon>
              <h1 class="auth-heading mt-4" style="text-align: center">
                That link didn't work
              </h1>
              <p class="auth-subtext" style="text-align: center">
                {{ verificationError }}
              </p>
              <p
                class="text-body-2"
                style="color: var(--text-secondary); margin-bottom: 16px"
              >
                If your link has expired, you can request a new verification
                email from the login page.
              </p>
              <v-btn class="auth-submit-btn" large to="/login">
                Back to login
              </v-btn>
            </div>

            <!-- No token state -->
            <div v-else class="text-center py-4">
              <v-icon color="warning" size="56">mdi-link-off</v-icon>
              <h1 class="auth-heading mt-4" style="text-align: center">
                Invalid link
              </h1>
              <p class="auth-subtext" style="text-align: center">
                This verification link is invalid or missing. Please check your
                email for the correct link.
              </p>
              <v-btn class="auth-submit-btn mt-2" large to="/login">
                Back to login
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

        <div class="auth-footer-links">
          <a :href="landingUrl" target="_blank" rel="noopener"
            >About {{ $config.productName }}</a
          >
          <span class="auth-footer-sep">·</span>
          <a :href="'mailto:' + $config.SUPPORT_EMAIL">Support</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthBrandHeader from "../components/AuthBrandHeader.vue";

export default {
  name: "VerifyEmailView",
  components: {
    AuthBrandHeader
  },
  data() {
    return {
      verifying: true,
      verified: false,
      verificationError: null,
      token: ""
    };
  },
  computed: {
    landingUrl() {
      return process.env.VUE_APP_LANDING_PAGE_URL || "https://multisaas.com";
    }
  },
  async created() {
    // Get token from route params
    this.token = this.$route.params.token;

    if (!this.token) {
      this.verifying = false;
      return;
    }

    // Verify the email
    await this.verifyEmail();
  },
  methods: {
    async verifyEmail() {
      try {
        await this.$store.dispatch("verifyEmail", this.token);
        this.verified = true;
      } catch (error) {
        console.error("Email verification failed:", error);
        var errorDetail = "Failed to verify email. The link may have expired.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.detail
        ) {
          errorDetail = error.response.data.detail;
        }
        this.verificationError = errorDetail;
      } finally {
        this.verifying = false;
      }
    }
  }
};
</script>
